export type CustomerFilters = {
  businessPartnerRefCodeBusinessName: string
  regNumber: string
}

export const INITIAL_CUSTOMER_FILTERS: CustomerFilters = {
  businessPartnerRefCodeBusinessName: "",
  regNumber: "",
}
